import Config from './uiConfig';

export const ENVIRONMENT = Config.ENVIRONMENT || 'ppe';
